
/* We're using Coffeescript-style bound functions on object. This allows us to
 * ensure that event handlers defined on our Jitensha object can access the
 * Jitensha object.
 */
// var __bind = function(fn, me) {
//     return function() {
//         return fn.apply(me, arguments);
//     };
// };

/* This is the theme "class."
 */
var Jitensha = (function() {

    function Jitensha() {

        this.settings = {
            slideshowDelay: 5000,
            slideshowSpeed: 250,
            accentColor: "#44b3e3"
        };

        this.enableSlideshow();
        this.styleForms();
        this.styleProductImages();
        this.enableMasonry();
        this.setupNavigation();
        this.responsiveCollectionImages();
        this.setupBlogShareButton();
        this.redirectOnSelectChange();
        this.resizeVideos();

        
        if ($(document.body).hasClass("template-index") && $.cookie("recentlyViewedProducts")) {
            this.setupRecentlyViewedProducts();
        }

        if ($(document.body).hasClass("template-product")) {
            this.saveProduct();
        }
        

        
        if ($(document.body).hasClass("template-collection")) {
            this.collectionSorting();
        }
        

        if ($(document.body).hasClass("has-sidebar")) {
            this.fetchTweets();
        }

        var _that = this;

        
            $(window).resize(function(){
                _that.fixWonkyLogo();
            }).trigger("resize");
        

        $(window).resize(function(){
            if (document.documentElement.offsetWidth > 720) {
                _that.setupSlideshow("desktop");
            } else {
                _that.setupSlideshow("mobile");
            }
        }).trigger("resize");

        $(window).load(function() {
            $(document.body).removeClass("loading-theme");
        });

        $(".collection-products").imagesLoaded(function(){
            $(".collection-product-image").addClass("processed");
        });
    }

    Jitensha.prototype.redirectOnSelectChange = function() {

        $("select.loc_on_change").change(function () {
            if ($(this).attr("value") == "#") return false;
            window.location = $(this).attr("value");
        });

    };

    Jitensha.prototype.setupBlogShareButton = function() {

        var shareIconsVisible;

        $("html").click(function() {

            if ($(".blog_share_icons").css("display") === "none") {
                shareIconsVisible = false;
            } else {
                shareIconsVisible = true;
            }

            if (shareIconsVisible) {
                $(".blog_share_icons").animate({
                    opacity: 0,
                    top: "10px"
                }, 200, function () {
                    $(this).css({
                        display: -1337
                    }).toggle()
                });
                shareIconsVisible = false;
            }

        });

        $(".blog_share").click(function (event) {

            if ($(this).children(".blog_share_icons").css("display") == "none") {
                shareIconsVisible = false;
            } else {
                shareIconsVisible = true;
            }

            if (shareIconsVisible) {

                $(this).children(".blog_share_icons").animate({
                    opacity: 0,
                    top: "10px"
                }, 200, function () {
                    $(this).css("display", -1337).toggle()
                });
                shareIconsVisible = false;

            } else {

                $(this).children(".blog_share_icons").css("z-index", 7337).toggle().animate({
                    opacity: 1,
                    top: "25px"
                }, 200);
                shareIconsVisible = true;

            }

            event.stopPropagation();

        });

    };

    Jitensha.prototype.responsiveCollectionImages = function() {

        if( $(".collection-products").hasClass("fixed-layout") ) {
            var reverseImageRatio = parseInt(300, 10) / 300;

            $(".collection-product-image").css({
                paddingBottom: reverseImageRatio * 100 + "%"
            });
        }
    };

    Jitensha.prototype.collectionSorting = function() {

        $(".collection-sorting select").change(function(){
            var Sorting = {};
            Sorting.sort_by = $(".collection-sorting select").val();

            if ($(".collection-sorting").hasClass("vendor-collection")) {
                var currentSearch = location.search,
                    searchParts = currentSearch.split("&");

                for(var i = searchParts.length; i--;) {
                  if(searchParts[i].indexOf("sort_by") !== -1) {
                      searchParts.splice(i, 1);
                  }
                }

                var search = searchParts.join("&");
                location.search = search + "&" + jQuery.param(Sorting);
            } else {
                location.search = jQuery.param(Sorting);
            }
        });
    };

    Jitensha.prototype.setupNavigation = function() {

        /* Add placeholder text.
         */
        $("input[placeholder]").each(function () {

            var $this = $(this);

            $this.val($this.attr("placeholder"));

            $this.focus(function () {
                if ($this.val() == $this.attr("placeholder")) {
                    $this.val("");
                }
            });

            $this.blur(function () {
                if ($this.val() == "") {
                    $this.val($this.attr("placeholder"));
                }
            });

        });

        $(".mobile-navigation-toggle").click(function(e) {
            return $(".navigation").toggleClass("open");
        });

        $(".navigation .mobile-tier-toggle").click(function(e) {
            $(e.target).closest(".has-dropdown").toggleClass("open");
            return false;
        });
    };

    Jitensha.prototype.enableMasonry = function() {

        if( $(".collection-products.fluid-layout").length == 0 ) { return }

        $(".collection-products.fluid-layout").imagesLoaded( function() {
            var masonry = new Masonry(".collection-products.fluid-layout", {
                itemSelector: ".collection-product",
                transitionDuration: 0
            });

            masonry.bindResize();

            masonry.on("layoutComplete", function() {
                $(".collection-products").addClass("masonry-layout-complete");
                return true;
            });

            masonry.layout();
        });

    };

    Jitensha.prototype.styleProductImages = function() {
        if (!window.img_data) { return; }

        this.productImagessWrapper = $("#product-photos");
        this.productImages  = this.productImagessWrapper.find("#image");

        var current_image = 0;

        if (img_data.length <= 1) return;

        this.activeProductImage = this.productImagessWrapper.find("a:first");
        this.waiting = false;

        var _that = this;
        this.productImagessWrapper.find("ul li a").each(function (n) {
            $(this).attr("data-index", n);
            $(this).click(function () {
                if (_that.waiting) return false;
                _that.waiting = true;
                _that.productImagessWrapper.find("ul li.active").removeClass("active");
                $(this).parent().addClass("active");
                _that.showNextProductImage(n);
                return false;
            });
        });

        this.adjustProductImages();
        $(window).resize(this.adjustProductImages);
    };

    Jitensha.prototype.showNextProductImage = function(n) {

        this.productImages.css({
            height: this.activeProductImage.outerHeight()
        });

        var _that = this;
        this.activeProductImage.fadeOut("fast", function () {
            _that.loadProductImage(n);
        });
    };

    Jitensha.prototype.loadProductImage = function(n) {
        if (img_data[n].loaded) {

            this.showProductImage(n);

        } else {

            $("#photo-frame-bottom .cropper").addClass("loading");
            this.productImages.append("<a href='' id='product-img-" + n + "'><img src=''  class='product-photo-large' /></a>");
            var html = $("#product-img-" + n).hide();
            var _that = this;
            $(html).fancybox();
            $(html).find("img:first").load(function () {

                img_data[n].loaded = true;
                $("#photo-frame-bottom .cropper").removeClass("loading");
                _that.showProductImage(n);

            });

            this.productImages.addClass("loading");
            $(html).attr("href", img_data[n].src);
            $(html).find("img:first").attr("src", img_data[n].src);

        }
    };

    Jitensha.prototype.showProductImage = function(n) {

        this.activeProductImage.removeClass("active");
        this.activeProductImage = $("#product-img-" + n);

        this.activeProductImage.css({
            position: "absolute"
        });

        var _that = this;
        this.productImages.animate({
            height: _that.activeProductImage.outerHeight()
        }, "fast", function() {
            _that.productImages.removeClass("loading");
            $("#product-img-" + n).fadeIn("normal", function () {
                _that.waiting = false;
            }).addClass("active");
        });
    }

    Jitensha.prototype.adjustProductImages = function() {

        if ($("#image a").length > 1) {
            var newHeight = $("#image .active img").outerHeight();
            $("#image .active").height(newHeight)
            $("#image").height(newHeight)
        }
    }

    Jitensha.prototype.styleForms = function() {
        $(".home-shop-by select").uniform({ selectClass: "homeselector" });
        $(".uniform").uniform({ selectClass: "selector" });
    };

    Jitensha.prototype.enableSlideshow = function() {
        // Find the slideshow.
        this.slideshow = $(".home-slideshow");

        // Resize marquee text.
        $(".slideshow-slide-price").makeTextFit({
            min_size: 10,
            max_size: 57
        });

        this.slides = this.slideshow.find(".slideshow-slide");
        this.currentSlide = this.slides.first();
        this.slideZ = 101;

        var _that = this;

        if (this.slides.length > 1) {
            setInterval(function() {
                _that.advanceSlideshow();
            }, this.settings.slideshowDelay);
        }
    };

    Jitensha.prototype.advanceSlideshow = function() {

        if (this.slides.eq(0).outerHeight() == 0) {
            setTimer();
            return;
        }

        this.slides.css({
            position: "absolute"
        });

        this.currentSlide.find(".slide_content") .fadeTo(this.settings.slideshowSpeed, 0);

        var nextSlide = this.currentSlide.next();
        if (!nextSlide.length) nextSlide = this.slides.first();

        nextSlide.css({
            "display": "none",
            "z-index": ++this.slideZ
        }).fadeIn(this.settings.slideshowSpeed);

        nextSlide.find(".slide_content")
            .clearQueue()
            .delay(this.settings.slideshowSpeed * .75)
            .fadeTo(this.settings.slideshowSpeed, 1);

        this.currentSlide = nextSlide;

        this.slideshow.css({
            height: this.currentSlide.outerHeight()
        });

        var _that = this;

        $(window).resize(function(){
            _that.slideshow.css({
                height: _that.currentSlide.outerHeight()
            });
        });
    };

    Jitensha.prototype.setupSlideshow = function(layout) {
        var slideshow, slide, slideCount, slideIndex, currentSlide;
        slideshow = $(".home-slideshow");
        slide = $(".slideshow-slide");
        slideCount = slide.length;
        slideIndex = 0;

        while (slideIndex < slideCount) {
            currentSlide = slide[slideIndex];
            currentSlide = $(currentSlide);
            currentSlideContent = currentSlide.find(".slideshow-slide-content");
            currentSlideTag = currentSlide.find(".slideshow-slide-tag");

            if (layout == "desktop") {
                currentSlide.find("h2").prependTo(currentSlideContent);
            }
            else {
                currentSlide.find("h2").insertAfter(currentSlideTag);
            }

            slideIndex++
        }
    };

    Jitensha.prototype.saveProduct = function() {
        var recentlyViewedProducts = [
            $.cookie("recentlyViewedProducts")
        ];

        recentlyViewedProducts.unshift($(".product-header").data("handle"));

        $.cookie("recentlyViewedProducts", recentlyViewedProducts, { expires: 90, path: '/' });
    };

    Jitensha.prototype.setupRecentlyViewedProducts = function() {
        var productItems = $.cookie("recentlyViewedProducts").split(","),
            count = 1,
            countMax = 6,
            uniqueProductItems = [];
        Shopify.queue = [];

        $.each(productItems, function(index, product) {
            if ($.inArray(product, uniqueProductItems) == -1 && product != "" && count <= countMax) {
                uniqueProductItems.push(product);
                Shopify.queue.push({
                    handle: product
                });
                count++;
            }
        });

        Shopify.moveAlong = function() {
            var productContainer = $(".recently-viewed-products");
            if (Shopify.queue.length) {
                var request = Shopify.queue.shift();
                Shopify.getProduct(request.handle, function(product){
                    productContainer.append("<div class='compact-product'><a href='" + product.url + "'><img src='" + product.featured_image + "' alt='" + product.title + "' title='" + product.title + "' /></a></div>")
                    Shopify.moveAlong();
                });
            } else {
                productContainer.parent().removeClass("hidden");
            }
        };

        Shopify.moveAlong();
    };

    Jitensha.prototype.fetchTweets = function() {
        var config = {
            "profile": {"screenName": ""},
            "maxTweets": 3,
            "enableLinks": true,
            "showUser": true,
            "showTime": true,
            "showRetweet": true,
            "customCallback": this.renderTweets,
            "showInteraction": false
        }

        twitterFetcher.fetch(config);
    };

    Jitensha.prototype.renderTweets = function(tweets) {
        if (tweets.length) {
            count = 0;
            while (count < tweets.length) {
                $(".twitter-tweets").append(tweets[count]);
                count++;
            }
        }
        else {
            // twitterFetcher changes the view element to window, so we cannot use @$el here
            $(".twitter-widget").remove();
            console.log("No tweets to display. Most probable cause is an incorrectly entered Widget ID.");
        }
    };

    Jitensha.prototype.resizeVideos = function() {
        $(".main-content-wrapper").fitVids();
    };

    Jitensha.prototype.fixWonkyLogo = function() {
        // Fix logo ratios that cause the image to distort

        if ($("html").hasClass("ie8")) return;

        $(".logo").imagesLoaded(function() {
            if ($(".logo-retina").is(":visible")) {
                var logo = $(".logo-retina");
            } else {
                var logo = $(".logo-regular");
            };

            var naturalRatio = logo[0].naturalWidth / logo[0].naturalHeight;
            var actualRatio = logo[0].width / parseInt("250x60", 10);

            if (Math.round(naturalRatio * 100) / 100 != Math.round(actualRatio * 100) / 100) {
                var newHeight = "auto";
            } else {
                var newHeight = "250x60";
            };

            $(".logo-retina, .logo-regular").css("height", newHeight);
        });
    };

    return Jitensha;

}());

/* Initialize the theme.
 */

$(function() { new Jitensha(); });
